export const VERSION = '%WEB_COMPONENTS_VERSION%';
